// extracted by mini-css-extract-plugin
export var pillWrapper = "_ht-0";
export var showOverflow = "_ht-1";